import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "react-feather";

const RNANavbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".dropdown")) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const isActive = (path) => {
    return location.pathname === path
      ? { color: "var(--gold)" }
      : { color: "var(--text-primary)" };
  };

  const closeAllMenus = () => {
    setOpenDropdown(null);
    setIsMobileMenuOpen(false);
  };

  const navLinks = [
    { name: "Home", path: "/" },
    {
      name: "Practice Areas",
      submenu: [

        { name: "Dispute Resolution & Litigation", path: "/DisputeResolution" },
        { name: "Arbitration, Mediation & Conciliation", path: "/ArbitrationMediation" },
        { name: "Real Estate & Property law", path: "/RealEstateLaw" },
        { name: "Corporate & Commercial law", path: "/CorporateCommercialLaw" },
        { name: "Banking & Securitization", path: "/BankingSecuritization" },
        { name: "Taxation (Direct & Indirect)", path: "/TaxationLaw" },
        { name: "Intellectual Property", path: "/IntellectualPropertyLaw" }



      ],
    },
    {
      name: "About Us",
      submenu: [
        { name: "Our Story", path: "/about-us" },
        { name: "Our Team", path: "/ourteam" },
        { name: "Why choose Us", path: "/whychooseus" },

      ],
    },
    {
      name: "Useful Links",
      submenu: [
        { name: "Supreme Court of India", path: "https://www.sci.gov.in", external: true },
        { name: "Patna High Court", path: "https://patnahighcourt.gov.in", external: true },
        { name: "Live Law", path: "https://www.livelaw.in/", external: true },
        { name: "SCC Online", path: "https://www.scconline.com/?gad_source=1&gad_campaignid=22998236334&gbraid=0AAAAADb7l5OkgoElYtQGuzSuqrklJknlT&gclid=Cj0KCQiAnJHMBhDAARIsABr7b85rQgjOCN27iqR4Q9idUeS6nOdQ-Bv-eIsWpUBsc4D1iHqjwH4OKt4aAj3rEALw_wcB", external: true },
        { name: "Articles And Important News", path: "/Articles" },
      ], 
    },
    // { name: "Testimonials", path: "/testimonials" },
    { name: "Contact Us", path: "/contact" },
  ];

  return (
    <header
      className="container-fluid px-0 fixed-top"
      style={{
        backgroundColor: scrolled ? "var(--cream)" : "transparent",
        boxShadow: scrolled ? "var(--shadow-soft)" : "none",
        transition: "var(--transition)",
      }}
    >
      {/* ===== Top Bar ===== */}
      <div
        className={`row gx-0 align-items-center d-none d-lg-flex ${scrolled ? "opacity-0 invisible" : "opacity-100 visible"
          }`}
        style={{
          height: scrolled ? "0" : "40px",
          backgroundColor: "var(--gold-light)",
          color: "var(--primary-dark)",
          transition: "var(--transition)",
        }}
      >
        <div className="col-lg-6 px-5 text-start">
          <small>
            <MapPin size={12} className="me-2" color="var(--gold)" />
            2nd Floor, Orchid Mall, Boring Road, Patna - 800013
          </small>
          <small className="ms-4">
            <Clock size={12} className="me-2" color="var(--gold)" />
            Mon–Thur 5.00 P.M. - 8.00 P.M.
          </small>
        </div>
        <div className="col-lg-6 px-5 text-end">
          <small>
            <Mail size={12} className="me-2" color="var(--gold)" />
            rnalawchambers@gmail.com
          </small>
          <small className="ms-4">
            <Phone size={12} className="me-2" color="var(--gold)" />
            +91 94734 25998
          </small>
        </div>
      </div>

      {/* ===== Navbar ===== */}
      <nav className="navbar navbar-expand-lg py-2 px-lg-5">
        {/* Logo */}
        <Link
          to="/"
          className="navbar-brand d-flex align-items-center ms-3"
          onClick={closeAllMenus}
          style={{ color: "var(--primary-dark)" }}
        >
          <img
            src="logo.jpeg"
            alt="RNA Law Chambers Logo"
            className="me-3"
            style={{ height: "70px", width: "auto" }}
          />

          <div className="d-flex flex-column">
            <span className="fw-bold" style={{ fontSize: "20px" }}>
              RNA Law Chambers
            </span>
            <small className="text-muted" style={{ letterSpacing: "0.5px", fontSize: "11px" }}>
              Justice • Integrity • Excellence
            </small>
          </div>
        </Link>


        {/* Toggler */}
        <button
          className="navbar-toggler me-4 d-lg-none"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          style={{
            border: "1.5px solid var(--primary-dark)",
            borderRadius: "8px",
            padding: "6px 10px",
          }}
        >
          ☰
        </button>

        {/* Menu */}
        <div
          className={`collapse navbar-collapse ${isMobileMenuOpen ? "show" : ""}`}
          style={{
            background: window.innerWidth <= 991 ? "var(--cream)" : "transparent",
          }}
        >
          <div className="navbar-nav ms-auto p-4 p-lg-0">
            {navLinks.map((link, i) => (
              <div
                key={i}
                className="nav-item dropdown"
                onMouseEnter={() =>
                  window.innerWidth > 992 && setOpenDropdown(i)
                }
                onMouseLeave={() => window.innerWidth > 992 && setOpenDropdown(null)}
              >
                {link.submenu ? (
                  <>
                    <span
                      className="nav-link dropdown-toggle fw-bold"
                      style={{ cursor: "pointer", ...isActive(link.path) }}
                      onClick={() =>
                        setOpenDropdown(openDropdown === i ? null : i)
                      }
                    >
                      {link.name}
                    </span>

                    <div
                      className={`dropdown-menu m-0 ${openDropdown === i ? "show" : ""}`}
                      style={{
                        display: openDropdown === i ? "block" : "none",
                        backgroundColor: "var(--cream)",
                      }}
                    >
                      {link.submenu.map((sub, j) => (
                        <Link
                          key={j}
                          to={sub.path}
                          className="dropdown-item fw-semibold"
                          onClick={closeAllMenus}
                          style={{ color: "var(--primary-dark)" }}
                          target={sub.external ? "_blank" : "_self"}
                          rel={sub.external ? "noopener noreferrer" : undefined}
                        >
                          {sub.name}
                        </Link>
                      ))}
                    </div>
                  </>
                ) : (
                  <Link
                    to={link.path}
                    className="nav-link fw-bold"
                    style={isActive(link.path)}
                    onClick={closeAllMenus}
                  >
                    {link.name}
                  </Link>
                )}
              </div>
            ))}
          </div>
        </div>
      </nav>
    </header>
  );
};

export default RNANavbar;
